import api from '../../../services/Api';
import { IAuditoriaRotatividadeProvisoesResultado } from '../interfaces/IAuditoriaRotatividadeProvisoes';

export const AuditoriaRotatividadeProvisoesService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaRotatividadeProvisoesResultado> {
    const response = await api.get<IAuditoriaRotatividadeProvisoesResultado>('auditoria-rotatividade-provisoes/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoContabil: '',
        fundamentacaoFiscal: '',
        provisoesPendentes: [],
        provisoesConciliadas: [],
      }
    );
  },
};
